import React from "react";
import { Header } from "../Header";
import { Outlet } from "react-router-dom";
import { Footer } from "../Footer";

export const Layout: React.FC = () => {
  return (
    <div className="layout-wrapper d-flex flex-column position-relative">
      <div className="image-layer position-absolute top-0 left-0 w-100 bottom-0 h-100"></div>
      <Header />
      <main className="px-2 px-md-4 flex-grow-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
